import { FilterArrayType } from 'common/components/Filters';
import { InvoicesOrderBy } from 'common/types/globalTypes';
import { OrderDirection, SortOrder } from 'common/utils/commonTypes';

type OrderLookup = {
  [direction in OrderDirection]: InvoicesOrderBy[];
};

const orderByMap = new Map<string, OrderLookup>([
  [
    'transactionType',
    {
      [OrderDirection.ASC]: [
        'INVOICE_TRANSACTION_TYPE_BY_TRANSACTION_TYPE_ID__TRANSACTION_TYPE_ASC',
      ],
      [OrderDirection.DESC]: [
        'INVOICE_TRANSACTION_TYPE_BY_TRANSACTION_TYPE_ID__TRANSACTION_TYPE_DESC',
      ],
    },
  ],
  [
    '_accountingStampTransactionReference',
    {
      [OrderDirection.ASC]: [
        '_ACCOUNTING_STAMP_TRANSACTION_REFERENCE_ASC',
      ],
      [OrderDirection.DESC]: [
        '_ACCOUNTING_STAMP_TRANSACTION_REFERENCE_DESC',
      ],
    },
  ],
  [
    'businessUnit',
    {
      [OrderDirection.ASC]: [
        'COMPANY_BUSINESS_UNIT_BY_BUSINESS_UNIT_ID__NAME_ASC',
      ],
      [OrderDirection.DESC]: [
        'COMPANY_BUSINESS_UNIT_BY_BUSINESS_UNIT_ID__NAME_DESC',
      ],
    },
  ],
  [
    'name',
    {
      [OrderDirection.ASC]: ['VENDOR_REFERENCE_ASC'],
      [OrderDirection.DESC]: ['VENDOR_REFERENCE_DESC'],
    },
  ],
  [
    'description',
    {
      [OrderDirection.ASC]: ['DESCRIPTION_ASC'],
      [OrderDirection.DESC]: ['DESCRIPTION_DESC'],
    },
  ],
  [
    'department',
    {
      [OrderDirection.ASC]: [
        'COMPANY_DEPARTMENT_BY_DEPARTMENT_ID__NAME_ASC',
      ],
      [OrderDirection.DESC]: [
        'COMPANY_DEPARTMENT_BY_DEPARTMENT_ID__NAME_DESC',
      ],
    },
  ],
  [
    'invoiceNumber',
    {
      [OrderDirection.ASC]: ['INVOICE_NUMBER_ASC'],
      [OrderDirection.DESC]: ['INVOICE_NUMBER_DESC'],
    },
  ],
  [
    'date',
    {
      [OrderDirection.ASC]: ['INVOICE_DATE_ASC'],
      [OrderDirection.DESC]: ['INVOICE_DATE_DESC'],
    },
  ],
  [
    'amount',
    {
      [OrderDirection.ASC]: ['CONTROL_TOTAL_AMOUNT_ASC'],
      [OrderDirection.DESC]: ['CONTROL_TOTAL_AMOUNT_DESC'],
    },
  ],
  [
    '_baseCurrencyAmount',
    {
      [OrderDirection.ASC]: ['_BASE_CURRENCY_AMOUNT_ASC'],
      [OrderDirection.DESC]: ['_BASE_CURRENCY_AMOUNT_DESC'],
    },
  ],
  [
    '_spotCurrencyAmount',
    {
      [OrderDirection.ASC]: ['_SPOT_CURRENCY_AMOUNT_ASC'],
      [OrderDirection.DESC]: ['_SPOT_CURRENCY_AMOUNT_DESC'],
    },
  ],
  [
    'currency',
    {
      [OrderDirection.ASC]: [
        'COMPANY_CURRENCY_BY_CURRENCY_ID__ISO_CODE_ASC',
      ],
      [OrderDirection.DESC]: [
        'COMPANY_CURRENCY_BY_CURRENCY_ID__ISO_CODE_DESC',
      ],
    },
  ],
  [
    '_createdByUserName',
    {
      [OrderDirection.ASC]: ['_CREATED_BY_USER_NAME_ASC'],
      [OrderDirection.DESC]: ['_CREATED_BY_USER_NAME_DESC'],
    },
  ],
  [
    'status',
    {
      [OrderDirection.ASC]: [
        'STATUS_TYPE_BY_STATUS_TYPE_ID__STATUS_TYPE_ASC',
      ],
      [OrderDirection.DESC]: [
        'STATUS_TYPE_BY_STATUS_TYPE_ID__STATUS_TYPE_DESC',
      ],
    },
  ],
  [
    '_accountingStampDate',
    {
      [OrderDirection.ASC]: ['_ACCOUNTING_STAMP_DATE_ASC'],
      [OrderDirection.DESC]: ['_ACCOUNTING_STAMP_DATE_DESC'],
    },
  ],
  [
    '_accountingStampTransactionReference',
    {
      [OrderDirection.ASC]: [
        '_ACCOUNTING_STAMP_TRANSACTION_REFERENCE_ASC',
      ],
      [OrderDirection.DESC]: [
        '_ACCOUNTING_STAMP_TRANSACTION_REFERENCE_DESC',
      ],
    },
  ],
  [
    '_accountingStampUserName',
    {
      [OrderDirection.ASC]: ['_ACCOUNTING_STAMP_USER_NAME_ASC'],
      [OrderDirection.DESC]: ['_ACCOUNTING_STAMP_USER_NAME_DESC'],
    },
  ],
  [
    '_accountingStampDate',
    {
      [OrderDirection.ASC]: ['_ACCOUNTING_STAMP_DATE_ASC'],
      [OrderDirection.DESC]: ['_ACCOUNTING_STAMP_DATE_DESC'],
    },
  ],
  [
    'requesterName',
    {
      [OrderDirection.ASC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__REQUESTER_NAME_ASC',
      ],
      [OrderDirection.DESC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__REQUESTER_NAME_DESC',
      ],
    },
  ],
  [
    'requesterDate',
    {
      [OrderDirection.ASC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__REQUESTER_DATE_ASC',
      ],
      [OrderDirection.DESC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__REQUESTER_DATE_DESC',
      ],
    },
  ],
  [
    'approvers',
    {
      [OrderDirection.ASC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__APPROVERS_ASC',
      ],
      [OrderDirection.DESC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__APPROVERS_DESC',
      ],
    },
  ],
  [
    'approvedDate',
    {
      [OrderDirection.ASC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__APPROVED_DATE_ASC',
      ],
      [OrderDirection.DESC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__APPROVED_DATE_DESC',
      ],
    },
  ],
  [
    'rejectors',
    {
      [OrderDirection.ASC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__REJECTORS_ASC',
      ],
      [OrderDirection.DESC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__REJECTORS_DESC',
      ],
    },
  ],
  [
    'rejectedDate',
    {
      [OrderDirection.ASC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__REJECTED_DATE_ASC',
      ],
      [OrderDirection.DESC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__REJECTED_DATE_DESC',
      ],
    },
  ],
  [
    'amendedByName',
    {
      [OrderDirection.ASC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__AMENDED_BY_NAME_ASC',
      ],
      [OrderDirection.DESC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__AMENDED_BY_NAME_DESC',
      ],
    },
  ],
  [
    'amendedDate',
    {
      [OrderDirection.ASC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__AMENDED_DATE_ASC',
      ],
      [OrderDirection.DESC]: [
        'APPROVAL_ENTITY_APPROVER_BY_ID__AMENDED_DATE_DESC',
      ],
    },
  ],
  [
    'production',
    {
      [OrderDirection.ASC]: ['COMPANY_BY_COMPANY_ID__NAME_ASC'],
      [OrderDirection.DESC]: ['COMPANY_BY_COMPANY_ID__NAME_DESC'],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder) => {
  const orderByArray: InvoicesOrderBy[] = [
    '_ACCOUNTING_STAMP_TRANSACTION_REFERENCE_ASC',
    'PRIMARY_KEY_ASC',
  ];
  if (!sort) return orderByArray;

  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return [...(orderBy ? orderBy : []), ...orderByArray];
};

export const toFilterVariable = (filterList: FilterArrayType[]) =>
  filterList.map((filter) => {
    switch (filter.filterKey) {
      case 'transactionTypeId':
      case 'businessUnitId':
      case 'departmentId':
      case 'corporatePeriodId':
      case '_statusTypeId':
      case '_companyId':
      case '_isHistory':
      case 'currencyId':
      case '_createdByUserid':
        return {
          [filter.filterKey]: {
            equalTo: filter.value,
          },
        };
      default:
        return undefined;
    }
  });
